/**
 * Analytics identifiers for BACKYARD WELDING PLANS™.
 * Leave a value empty to keep that integration switched off.
 */
export const META_PIXEL_ID = '1118212593897448'
export const CLARITY_PROJECT_ID = ''
export const FACEBOOK_DOMAIN_VERIFICATION = ''
